import { render, staticRenderFns } from "./OrderTicket.vue?vue&type=template&id=25747515&scoped=true&"
import script from "./OrderTicket.vue?vue&type=script&lang=js&"
export * from "./OrderTicket.vue?vue&type=script&lang=js&"
import style0 from "./OrderTicket.vue?vue&type=style&index=0&id=25747515&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25747515",
  null
  
)

export default component.exports